import React, { useState, useEffect } from "react";
import "./SlideShow.css";
import image1 from "../../assets/slideshow/1.webp";
import image2 from "../../assets/slideshow/2.webp";
import image3 from "../../assets/slideshow/3.webp";
import image4 from "../../assets/slideshow/4.webp";
import image5 from "../../assets/slideshow/5.webp";
import image6 from "../../assets/slideshow/6.webp";
import image7 from "../../assets/slideshow/7.webp";
import image8 from "../../assets/slideshow/8.webp";
import image9 from "../../assets/slideshow/9.webp";
import image10 from "../../assets/slideshow/10.webp";
import image11 from "../../assets/slideshow/11.webp";
import image12 from "../../assets/slideshow/12.webp";
import image13 from "../../assets/slideshow/13.webp";
import image14 from "../../assets/slideshow/14.webp";
import image15 from "../../assets/slideshow/15.webp";
import image16 from "../../assets/slideshow/16.webp";
import image17 from "../../assets/slideshow/17.webp";

const SlideShow = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    {
      url: image1,
      title: "O ŠÍPKOVÉ RŮŽENCE",
      subtitle: "Činoherní humorná pohádka pro děti",
    },
    { url: image2, title: '"Dávám ti do vínku auto a vilu."' },
    { url: image3, title: '"Tady máte ruku mou, budu Vaší Růženou."' },
    {
      url: image4,
      title: "JAK HONZA KE ŠTĚSTÍ PŘIŠEL",
      subtitle: "Činoherní veselá pohádka pro děti",
    },
    {
      url: image5,
      title: '"Když mám hlad, tak zastavím, sednu si, krávu podojím."',
    },
    {
      url: image6,
      title: "SPOLU",
      subtitle: "Činoherní něžná komedie z manželského života",
    },
    {
      url: image7,
      title: '"Jako bublinka vodováhy?"',
      title2: '"Základ rovnováhy."',
    },
    {
      url: image8,
      title: "NA PAVLAČI",
      subtitle: "Činoherní komedie o dvou padesátnicích provoněná kávou",
    },
    {
      url: image9,
      title: '"To musíš přeprogramovat, vytvořit novou matrici."',
    },
    {
      url: image10,
      title: "POTRESTANÁ PÝCHA",
      subtitle: "Činoherní veselá pohádka o pyšné princezně",
    },
    {
      url: image11,
      title: '"Každá žena je pro muže výzva, zvlášť, když je to princezna."',
    },
    {
      url: image12,
      title: "VÁNOČNÍ ZEMĚKOULE",
      subtitle: "Činoherní laskavá a humorná pohádka jednoho herce",
    },
    {
      url: image13,
      title: '"To budete koukat, co se nám to upeklo!"',
    },
    {
      url: image14,
      title: "TŘI",
      subtitle: "Absurdní drama",
    },
    {
      url: image15,
      title: '"I kdyby byl ministr pořádná kost."',
    },
    {
      url: image16,
      title: "ZLATÁ RYBKA",
      subtitle: "Činoherní veselá pohádka pro děti",
    },
    {
      url: image17,
      title:
        '"Ještě řekni že jabloně a já se proměním na koně. Jejdanenky! Musím si dát pozor na to, co říkám!"',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  const goToPreviousSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <>
      <div className='slideshow-container'>
        <div className='navigation-arrows'>
          <button className='arrow left-arrow' onClick={goToPreviousSlide}>
            &#10094;
          </button>
          <button className='arrow right-arrow' onClick={goToNextSlide}>
            &#10095;
          </button>
        </div>
        {images.map((image, index) => (
          <div
            key={index}
            className={`slide ${index === currentIndex ? "active" : ""}`}
            style={{ backgroundImage: `url(${image.url})` }}
          >
            <div className='slide-title'>
              {image.title}
              <br />
              {image.title2}
              <div className='slide-subtitle'>{image.subtitle}</div>
            </div>
          </div>
        ))}
        <div className='dots'>
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
      </div>
    </>
  );
};

export default SlideShow;
